module.exports = __webpack_public_path__ + "img/hr.983204b7.svg";